import React, { createContext, useContext } from 'react';
import personalInfo from '../data/personalInfo';
import educationData from '../data/education';
import experienceData from '../data/experience';
import projectsData from '../data/projects';
import skillsData from '../data/skills';

const AppContext = createContext();

export const AppProvider = ({ children }) => {
  return (
    <AppContext.Provider
      value={{
        personalInfo,
        educationData,
        experienceData,
        projectsData,
        skillsData,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = () => {
  const context = useContext(AppContext);
  if (context === undefined) {
    throw new Error('useAppContext must be used within an AppProvider');
  }
  return context;
};